import {SummaryModel} from '../../../../entity/summary.model';
import {DocumentSummaryModel} from '../../../../../document/common/api/model/documentSummary.model';
import {PermissionsModel} from '../../../../entity/permissions.model';

export class AudioRecordSummaryModel implements SummaryModel {
    id: number;
    permissions: PermissionsModel;
    document: DocumentSummaryModel;
    msDuration: number;
}
